/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Doc recognition error: Barcode data to document mismatch
 * @export
 * @interface PaxCheckBarcodeToDocMismatch
 */
export interface PaxCheckBarcodeToDocMismatch {
    /**
     * 
     * @type {string}
     * @memberof PaxCheckBarcodeToDocMismatch
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckBarcodeToDocMismatch interface.
 */
export function instanceOfPaxCheckBarcodeToDocMismatch(value: object): value is PaxCheckBarcodeToDocMismatch {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckBarcodeToDocMismatchFromJSON(json: any): PaxCheckBarcodeToDocMismatch {
    return PaxCheckBarcodeToDocMismatchFromJSONTyped(json, false);
}

export function PaxCheckBarcodeToDocMismatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckBarcodeToDocMismatch {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
    };
}

export function PaxCheckBarcodeToDocMismatchToJSON(json: any): PaxCheckBarcodeToDocMismatch {
    return PaxCheckBarcodeToDocMismatchToJSONTyped(json, false);
}

export function PaxCheckBarcodeToDocMismatchToJSONTyped(value?: PaxCheckBarcodeToDocMismatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
    };
}

